import axios from "axios";

axios.defaults.baseURL = 'https://www.meteosource.com/api/v1/free'

export default axios